import { apiSlice } from './api-slice';
import {
  AuthConfiguration,
  LoginData,
  Login,
  Response,
  ResetPasswordRequest,
  VerifyAccountData,
} from '../models';

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUserDetails: builder.query({
      query: () => ({
        url: 'authenticate/me',
        method: 'GET',
      }),
    }),
    getAuthConfiguration: builder.query<Response<AuthConfiguration>, void>({
      query: () => ({
        url: 'configuration/AUTHENTICATION',
        method: 'GET',
      }),
    }),
    // UNCHANGED contract — still the only endpoint that mints a session.
    login: builder.mutation<Response<Login>, LoginData>({
      query: data => ({
        url: 'crossbuildz/authenticate/login',
        method: 'POST',
        body: data,
      }),
    }),
    // `data` is always the empty string: the 6-digit OTP is emailed to the
    // admin and is never carried in the response body.
    forgetPassword: builder.mutation<Response<string>, { email: string }>({
      query: data => ({
        url: 'crossbuildz/authenticate/forgetPassword',
        method: 'POST',
        body: data,
      }),
    }),
    // Returns { userName, resetToken } — no accessToken/refreshToken.
    verifyAccount: builder.mutation<
      Response<VerifyAccountData>,
      { email: string; otp: string }
    >({
      query: data => ({
        url: 'crossbuildz/authenticate/verifyAccount',
        method: 'POST',
        body: data,
      }),
    }),
    // Requires exactly email + password + resetToken.
    resetPassword: builder.mutation<Response<string>, ResetPasswordRequest>({
      query: data => ({
        url: 'crossbuildz/authenticate/resetPassword',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetUserDetailsQuery,
  useGetAuthConfigurationQuery,
  useLoginMutation,
  useResetPasswordMutation,
  useVerifyAccountMutation,
  useForgetPasswordMutation,
} = authApiSlice;
